import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation createPost($group: String!, $text: String!, $imageIds: [String], $link: String) {
    createPost(group: $group, text: $text, imageIds: $imageIds, link: $link) {
      post {
        id
      }
    }
  }
`

export interface CreatePostInput {
  group: string
  text: string
  imageIds: string[]
  link?: string
}

export interface CreatePostOutput {
  createPost: {
    post: {
      id: string
    }
  }
}

export const useCreatePost = () => useMutation<CreatePostOutput, CreatePostInput>(mutation)
